import React from "react";
import WellnessComponent from "../components/Wellness/Wellness";

const Wellness = () => {
  return (
    <div>
      <WellnessComponent />
    </div>
  );
};

export default Wellness;
